module.exports = __webpack_public_path__ + "static/img/apple_logo.b9b731f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/icon/apple_logo.png
// module id = eCiI
// module chunks = 1